'use strict';
import BasePickerController from './mx-picker-base-controller';

export default class MultiPickerController extends BasePickerController {
	constructor($timeout, $q, $element, $scope, i18n) {
		super($timeout, $q, $element, $scope, i18n);
		this.single = false;
		this.__dropdownIdClass = 'mxAutoCompDrDownID-' + Math.random().toString().replace('.', '');
	}

	$onInit() {
		super.$onInit();
		this._setLabels();
	}

	$postLink() {
		this.$element
			.on('click', 'md-chips-wrap', (event) => {
				if (event.target.tagName !== 'INPUT') {
					this.$element.find('input').focus();
				}
			})
			.on('focus', 'input', () => {
				$('.md-autocomplete-suggestions-container:has(.' + this.__dropdownIdClass + ')')
					.addClass('mx-picker-dropdown-suggestions')
					.css({
						width: Math.round(this.$element.width()) + 'px',
						left: '0 !important',
						marginTop: '2px',
						marginLeft: Math.round(this.$element.offset().left) + 'px',
					});
			})
			.on('keydown', () => {
				this.$element.addClass('mx-picker--touched');
			});
	}

	convertValueWithSeparatorChar(value) {
		if (typeof value === 'string') {
			return value.split(this.separatorChar).map((value) => {
				value = value.trim();
				if (!isNaN(value)) {
					value = Number(value);
				}
				return value;
			});
		}
		return null;
	}

	filterSelectedItems(items) {
		if (items.length > 0 && this.selectedItems.length > 0) {
			const selectedIds = this.selectedItems.map((item) => this.getId(item));
			items = items.filter((item) => !selectedIds.includes(this.getId(item)));
		}
		return items;
	}

	onSelectionChange() {
		this.internalSet = true;
		this.model = this.selectedItemsToValue();
		this._setLabels();
		this.setNotFoundButtonAvailability(true);
		this.internalSet = false;
	}

	selectedItemsToValue() {
		if (this.selectedItems.length === 0) {
			return null;
		}
		const ids = this.selectedItems.map((item) => this.getId(item));
		return this.separatorChar ? ids.join(this.separatorChar) : ids;
	}

	setSelectedItems(items) {
		this.selectedItems = items;
		this._setLabels();
	}

	useDropdownLabelsDecorator(label, searchText) {
		const dropdownLabelsDecorator = this.dropdownLabelsDecorator || this._defaultDropdownLabelsDecorator;
		return dropdownLabelsDecorator(label, searchText);
	}

	_defaultDropdownLabelsDecorator(label, searchText) {
		label = label || '';
		searchText = searchText || '';
		var pos = label.toLowerCase().indexOf(searchText.toLowerCase());
		if (pos === 0) {
			label =
				label.substring(0, pos) +
				'<span class="mx-multipicker-dropdown-highlight">' +
				label.substring(pos, pos + searchText.length) +
				'</span>' +
				label.substring(pos + searchText.length);
		}
		return label;
	}
}
MultiPickerController.$inject = ['$timeout', '$q', '$element', '$scope', 'mx.internationalization'];
